import React, { useState, useEffect } from "react";
import DatePicker from "react-date-picker";

const AddQuotePopUp = props => {
  const [quoteLoad, setLoad] = useState({
    today: new Date(),
    customer: "",
    origin: "",
    destination: "",
    originState: "",
    destinationState: "",
    PUDate: new Date(),
    PUTime: "",
    PUflex: false,
    DODate: new Date(),
    DOTime: "",
    DOflex: false,
    equipment: "None",
    commodity: "",
    weight: "",
    tarp: "",
    dims: "",
    gwrate: 0,
    truckrate: 0,
    rateFlex: false,
    notes: "",
    googleMiles: 0,
    length: "",
    width: "",
    height: "",
    permits: "",
    escorts: "",
    policeEscorts: "",
    insurance: "",
    surveys: "",
    bucketTrucks: ""
  });

  const {
    customer,
    origin,
    destination,
    originState,
    destinationState,
    PUTime,
    PUflex,
    DOTime,
    DOflex,
    equipment,
    commodity,
    weight,
    tarp,
    dims,
    gwrate,
    truckrate,
    rateFlex,
    notes,
    PUDate,
    DODate,
    today,
    googleMiles,
    length,
    width,
    height,
    permits,
    escorts,
    policeEscorts,
    insurance,
    surveys,
    bucketTrucks
  } = quoteLoad;

  useEffect(() => {
    //Erases state when toggling pop up
    setLoad({
      ...quoteLoad,
      customer: "",
      origin: "",
      destination: "",
      PUTime: "",
      PUflex: false,
      DOTime: "",
      DOflex: false,
      equipment: "None",
      commodity: "",
      weight: "",
      tarp: "",
      dims: "",
      gwrate: 0,
      truckrate: 0,
      rateFlex: false,
      notes: "",
      PUDate: new Date(),
      DODate: new Date(),
      googleMiles: "",
      length: "",
      width: "",
      height: "",
      permits: "",
      escorts: "",
      policeEscorts: "",
      insurance: "",
      surveys: "",
      bucketTrucks: ""
    });
  }, []);

  const onChange = e =>
    setLoad({ ...quoteLoad, [e.target.name]: e.target.value.toUpperCase() });

  const onChangeNote = e =>
    setLoad({ ...quoteLoad, [e.target.name]: e.target.value });

  const changeFlexPU = () => {
    setLoad({ ...quoteLoad, PUflex: !PUflex });
  };
  const changeFlexDO = () => {
    setLoad({ ...quoteLoad, DOflex: !DOflex });
  };
  const changeRateFlex = () => {
    setLoad({ ...quoteLoad, rateFlex: !rateFlex });
  };
  const handlePUDate = e => {
    setLoad({ ...quoteLoad, PUDate: e });
  };
  const handleDODate = e => {
    setLoad({ ...quoteLoad, DODate: e });
  };
  const handleEquipment = e => {
    setLoad({ ...quoteLoad, equipment: e.target.value });
  };

  const onPost = () => {
    props.add(quoteLoad);
    props.toggle(15);
  };

  return (
    <div className="fixedPopUp">
      <div className="addOpenPopUp">
        <div className="newInputRow1 inputRow">
          <div>
            <label>Customer</label>
            <input
              type="text"
              name="customer"
              value={customer}
              onChange={onChange}
            />
          </div>
          <div>
            <label>Origin City</label>
            <input
              type="text"
              name="origin"
              value={origin}
              onChange={onChange}
            />
          </div>
          <div>
            <label>Origin State</label>
            <input
              type="text"
              name="originState"
              value={originState}
              onChange={onChange}
            />
          </div>
          <div>
            <label>Dest. City</label>
            <input
              type="text"
              name="destination"
              value={destination}
              onChange={onChange}
            />
          </div>
          <div>
            <label>Dest. State</label>
            <input
              type="text"
              name="destinationState"
              value={destinationState}
              onChange={onChange}
            />
          </div>
        </div>
        <div className="inputRow2 inputRow">
          <div>
            <label>Pick-Up Date</label>
            <div className="datePickerDiv">
              <DatePicker
                value={PUDate}
                onChange={handlePUDate}
                clearIcon={null}
                calendarIcon={null}
                className="xxDatePicker"
              />
            </div>
          </div>
          <div>
            <label>Pick-Up Time</label>
            <input
              type="text"
              name="PUTime"
              value={PUTime}
              onChange={onChange}
            />
          </div>
          <div style={{ width: "5%" }}>
            <label>Flex?</label>
            <div onClick={changeFlexPU} className={PUflex ? "flexOn" : "flex"}>
              <i className="fas fa-check checkIconPopUp"></i>
            </div>
          </div>
          <i className="fas fa-long-arrow-alt-right arrowIcon"></i>
          <div>
            <label>Drop-Off Date</label>
            <div className="datePickerDiv">
              <DatePicker
                value={DODate}
                onChange={handleDODate}
                clearIcon={null}
                calendarIcon={null}
                className="xxDatePicker"
              />
            </div>
          </div>
          <div>
            <label>Drop-Off Time</label>
            <input
              type="text"
              name="DOTime"
              value={DOTime}
              onChange={onChange}
            />
          </div>
          <div style={{ width: "5%" }}>
            <label>Flex?</label>
            <div onClick={changeFlexDO} className={DOflex ? "flexOn" : "flex"}>
              <i className="fas fa-check checkIconPopUp"></i>
            </div>
          </div>
        </div>
        <div className="inputRow3 inputRow">
          <div>
            <label>Equipment</label>
            <select onChange={handleEquipment}>
            <option
                name="equipment"
                value="None"
                selected={equipment === "None" ? true : false}
              >
                None
              </option>
              <option
                name="equipment"
                value="Flatbed"
                selected={equipment === "Flatbed" ? true : false}
              >
                Flatbed
              </option>
              <option
                name="equipment"
                value="SD"
                selected={equipment === "SD" ? true : false}
              >
                SD
              </option>
              <option
                name="equipment"
                value="FSD"
                selected={equipment === "FSD" ? true : false}
              >
                FSD
              </option>
              <option
                name="equipment"
                value="53' flatbed"
                selected={equipment === "53' flatbed" ? true : false}
              >
                53' flatbed
              </option>
              <option
                name="equipment"
                value="53' SD"
                selected={equipment === "53' SD" ? true : false}
              >
                53' SD
              </option>
              <option
                name="equipment"
                value="53' SD Con"
                selected={equipment === "53' SD Con" ? true : false}
              >
                53' SD Con
              </option>
              <option
                name="equipment"
                value="53' flatbed Con"
                selected={equipment === "53' flatbed Con" ? true : false}
              >
                53' flatbed Con
              </option>
              <option
                name="equipment"
                value="53' Van"
                selected={equipment === "53' Van" ? true : false}
              >
                53' Van
              </option>
              <option
                name="equipment"
                value="48' flatbed Con"
                selected={equipment === "48' flatbed Con" ? true : false}
              >
                48' flatbed Con
              </option>
              <option
                name="equipment"
                value="48' SD Con"
                selected={equipment === "48' SD Con" ? true : false}
              >
                48' SD Con
              </option>
              <option
                name="equipment"
                value="40' hotshot"
                selected={equipment === "40' hotshot" ? true : false}
              >
                40' hotshot
              </option>
              <option
                name="equipment"
                value="30' hotshot"
                selected={equipment === "30' hotshot" ? true : false}
              >
                30' hotshot
              </option>
              <option
                name="equipment"
                value="26' box truck"
                selected={equipment === "26' box truck" ? true : false}
              >
                26' box truck
              </option>
              <option
                name="equipment"
                value="20' hotshot"
                selected={equipment === "20' hotshot" ? true : false}
              >
                20' hotshot
              </option>

              <option
                name="equipment"
                value="Reefer"
                selected={equipment === "Reefer" ? true : false}
              >
                Reefer
              </option>
              <option
                name="equipment"
                value="VR"
                selected={equipment === "VR" ? true : false}
              >
                VR
              </option>
              <option
                name="equipment"
                value="PO"
                selected={equipment === "PO" ? true : false}
              >
                PO
              </option>
              <option
                name="equipment"
                value="RGN"
                selected={equipment === "RGN" ? true : false}
              >
                RGN
              </option>
              <option
                name="equipment"
                value="DD"
                selected={equipment === "DD" ? true : false}
              >
                DD
              </option>
            </select>
          </div>
          <div>
            <label>Commodity</label>
            <input
              type="text"
              name="commodity"
              value={commodity}
              onChange={onChange}
            />
          </div>
          <div>
            <label>Weight</label>
            <input
              type="text"
              name="weight"
              value={weight}
              onChange={onChange}
            />
          </div>
          <div>
            <label>Tarp</label>
            <input type="text" name="tarp" value={tarp} onChange={onChange} />
          </div>
          <div>
            <label>Dims</label>
            <input type="text" name="dims" value={dims} onChange={onChange} />
          </div>
        </div>
        <div className="inputRow3 inputRow">
          <div>
            <label>Google Miles</label>
            <input
              type="number"
              name="googleMiles"
              value={googleMiles}
              onChange={onChange}
            />
          </div>
          <div>
            <label>Length</label>
            <input
              type="text"
              name="length"
              value={length}
              onChange={onChange}
            />
          </div>
          <div>
            <label>Width</label>
            <input type="text" name="width" value={width} onChange={onChange} />
          </div>
          <div>
            <label>Height</label>
            <input
              type="text"
              name="height"
              value={height}
              onChange={onChange}
            />
          </div>
          <div>
            <label>Permits</label>
            <input
              type="text"
              name="permits"
              value={permits}
              onChange={onChange}
            />
          </div>
        </div>
        <div className="inputRow3 inputRow">
          <div>
            <label>Escorts</label>
            <input
              type="text"
              name="escorts"
              value={escorts}
              onChange={onChange}
            />
          </div>
          <div>
            <label>Police Escorts</label>
            <input
              type="text"
              name="policeEscorts"
              value={policeEscorts}
              onChange={onChange}
            />
          </div>
          <div>
            <label>Insurance</label>
            <input
              type="text"
              name="insurance"
              value={insurance}
              onChange={onChange}
            />
          </div>
          <div>
            <label>Surveys</label>
            <input
              type="text"
              name="surveys"
              value={surveys}
              onChange={onChange}
            />
          </div>
          <div>
            <label>Bucket Trucks</label>
            <input
              type="text"
              name="bucketTrucks"
              value={bucketTrucks}
              onChange={onChange}
            />
          </div>
        </div>
        <div className="inputRow4 inputRow">
          <div>
            <label>Greate Wide Rate</label>
            <input
              type="number"
              name="gwrate"
              value={gwrate}
              onChange={onChange}
            />
          </div>
          <div className="truckRateInputBigDiv">
            <div className="truckRateInput">
              <label>Truck Rate</label>
              <input
                type="number"
                name="truckrate"
                value={truckrate}
                onChange={onChange}
              />
            </div>
            <div className="truckRateInput" style={{ width: "30%" }}>
              <label style={{ marginLeft: "2vw" }}>Flexible?</label>
              <div
                onClick={changeRateFlex}
                className={rateFlex ? "flexOn" : "flex"}
              >
                <i className="fas fa-check checkIconPopUp"></i>
              </div>
            </div>
          </div>
        </div>
        <div className="inputRow5 inputRow">
          <div>
            <label>Notes</label>
            <textarea
              type="text"
              name="notes"
              value={notes}
              onChange={onChangeNote}
            />
          </div>
        </div>
        <div className="btnRow">
          <div className="btnRowFiller"></div>
          <div onClick={() => props.toggle(15)} className="cancelBtn">
            Cancel
          </div>
          <div onClick={onPost} className="postBtn">
            Add Quote
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddQuotePopUp;
